import FingerprintJS from '@fingerprintjs/fingerprintjs';

export interface DeviceCharacteristics {
  screen: {
    width: number;
    height: number;
    depth: number;
    pixelRatio: number;
  };
  timezone: string;
  language: string;
  platform: string;
  hardwareConcurrency?: number;
  deviceMemory?: number;
  maxTouchPoints?: number;
  userAgent: string;
}

export interface DeviceData {
  fingerprint: string;
  characteristics: DeviceCharacteristics;
  ip?: string;
}

// Get public IP address
const getPublicIP = async (): Promise<string | undefined> => {
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    return data.ip;
  } catch (error) {
    console.warn('Could not fetch public IP:', error);
    return undefined;
  }
};

// Generate device characteristics
const generateDeviceCharacteristics = (): DeviceCharacteristics => {
  return {
    screen: {
      width: window.screen.width,
      height: window.screen.height,
      depth: window.screen.colorDepth,
      pixelRatio: window.devicePixelRatio
    },
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    language: navigator.language,
    platform: navigator.platform,
    hardwareConcurrency: navigator.hardwareConcurrency || undefined,
    deviceMemory: (navigator as any).deviceMemory || undefined,
    maxTouchPoints: navigator.maxTouchPoints || undefined,
    userAgent: navigator.userAgent
  };
};

// Generate complete device fingerprint
export const generateDeviceFingerprint = async (): Promise<DeviceData> => {
  try {
    // Initialize FingerprintJS
    const fp = await FingerprintJS.load();
    
    // Get the visitor identifier
    const result = await fp.get();
    
    // Generate device characteristics
    const characteristics = generateDeviceCharacteristics();
    
    // Get public IP (optional)
    const ip = await getPublicIP();
    
    return {
      fingerprint: result.visitorId,
      characteristics,
      ip
    };
  } catch (error) {
    console.error('Error generating device fingerprint:', error);
    
    // Fallback: generate basic fingerprint without FingerprintJS
    const characteristics = generateDeviceCharacteristics();
    const fallbackFingerprint = btoa(JSON.stringify(characteristics)).substring(0, 32);
    
    return {
      fingerprint: fallbackFingerprint,
      characteristics,
      ip: undefined
    };
  }
}; 